module.exports = __webpack_public_path__ + "static/img/Manly.fccbb28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Manly.svg
// module id = vvjD
// module chunks = 1